import React from 'react';
import { Create } from 'react-admin';

import ProjectForm from '../../IirsaProjects/IirsaProjectForm';

function DraftProjectCreate(props) {
  return (
    <Create {...props}>
      <ProjectForm draft />
    </Create>
  );
}

export default DraftProjectCreate;
